var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCode = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    viewBox: "0 0 30 30",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A5A5A5",
    fillRule: "evenodd",
    d: "M20.024 1.938a.937.937 0 0 1 .538 1.211l-9.375 24.375a.937.937 0 1 1-1.75-.673l9.376-24.375a.94.94 0 0 1 1.211-.538M7.225 7.775a.937.937 0 0 1 0 1.325l-4.962 4.963 4.962 4.962A.937.937 0 1 1 5.9 20.35L.275 14.725a.937.937 0 0 1 0-1.325L5.9 7.775a.937.937 0 0 1 1.325 0M22.775 7.775a.937.937 0 0 1 1.325 0l5.625 5.625a.937.937 0 0 1 0 1.325L24.1 20.35a.937.937 0 0 1-1.325-1.325l4.962-4.962L22.775 9.1a.94.94 0 0 1 0-1.325",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCode);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/code.d25462b2.svg";